import SidebarTemplate from 'components/templates/SidebarTemplate';
import React from 'react';
import BankDepositImportLayout from './BankDepositImportLayout';
import { BankDetailProvider } from '../context/BankImportDetails';

const BankMasterPage = () => (
  <SidebarTemplate pageTitle="銀行入金データインポート">
    <BankDetailProvider>
      <BankDepositImportLayout />
    </BankDetailProvider>
  </SidebarTemplate>
);

export default BankMasterPage;
